'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.daysAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/daysAgo.js
// module id = 484
// module chunks = 0